// Package imports:
import React, { useEffect, useState } from 'react';
// Component imports:
import DisplayBox from '../../../components/DisplayBox/DisplayBox';
import Alert from '../../../ui-elements/Alert/Alert';
import Loading from '../../../ui-elements/Loading/Loading';
import VehiclesOwnedReportBody from '../../Okutaeki/SsnSearch/VehiclesOwnedReportBody';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { ICompanyReportModel } from '../../../types/CompanyTypes';
import { IVehicleReport } from '../../../types/VehicleTypes';
import { Fetched } from '../../../types/Types';
import { IKeldanApiResponse } from '../../../types/KeldanTypes';

const ViewVehiclesReport: React.FC<ICompanyReportModel>= ({
    id,
    eventId
}) => {
    const [ vehicleReport, setVehicleReport] = useState<Fetched<IVehicleReport>>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = `${GET_KELDAN_API_URL()}/Company/GetVehiclesReport/${id}?eventId=${eventId}`;
                const response = await fetch(url);
                if (response.ok) {
                    const responseBody: IKeldanApiResponse<IVehicleReport> = await response.json();
                    if (responseBody.result) {
                        setVehicleReport(responseBody.result);
                    } else if (responseBody.message) {
                        setVehicleReport(new Error(responseBody.message));
                    } else {
                        setVehicleReport(new Error(ErrorMessages.OtherShort));
                    }
                } else {
                    setVehicleReport(new Error(ErrorMessages.RequestFailed));
                }
            } catch (e) {
                setVehicleReport(new Error(ErrorMessages.NetworkError));
            }
        }
        fetchData();
    }, []);

    return vehicleReport === null
        ? <DisplayBox
            title='Ökutæki í eigu'
            className='KCL_ViewCompanyAssetsReport'
        >
            <Loading />
        </DisplayBox>
        : vehicleReport instanceof Error
        ? <DisplayBox
            title='Ökutæki í eigu'
            className='KCL_ViewCompanyAssetsReport'
        >
            <Alert
                type={
                    (vehicleReport.message === ErrorMessages.RequestFailed || vehicleReport.message === ErrorMessages.NetworkError)
                    ? 'error'
                    : 'alert'
                }
                headText={vehicleReport.message}
            />
        </DisplayBox>
        : <VehiclesOwnedReportBody
            id={id}
            eventId={eventId}
            vehicleReport={vehicleReport}
        />
}

export default ViewVehiclesReport;